import { NgModule } from "@angular/core";
import { PreloadAllModules, RouterModule, Routes } from "@angular/router";
import { AuthGuardService } from "./services/auth-guard.service";

const routes: Routes = [
  {
    path: "home",
    loadChildren: () =>
      import("./home/home.module").then((m) => m.HomePageModule),
    canActivate: [AuthGuardService],
  },
  {
    path: "",
    redirectTo: "home",
    pathMatch: "full",
  },
  {
    path: "login",
    loadChildren: () =>
      import("./login/login.module").then((m) => m.LoginPageModule),
  },
  {
    path: "users",
    loadChildren: () =>
      import("./admin/users/users.module").then((m) => m.UsersPageModule),
  },
  {
    path: "clients",
    loadChildren: () =>
      import("./agent/clients/clients.module").then((m) => m.ClientsPageModule),
  },
  {
    path: "teams",
    loadChildren: () =>
      import("./admin/teams/teams.module").then((m) => m.TeamsPageModule),
  },

  {
    path: "teams/:id",
    loadChildren: () =>
        import("./admin/teams/teams.module").then((m) => m.TeamsPageModule),
  },
  {
    path: "contracts",
    loadChildren: () =>
      import("./admin/contracts/contracts.module").then(
        (m) => m.ContractsPageModule
      ),
  },
  {
    path: "profile/:userId",
    loadChildren: () =>
      import("./profile/profile.module").then((m) => m.ProfilePageModule),
    canActivate: [AuthGuardService],
  },
  {
    path: "edit-user",
    loadChildren: () =>
      import("./edit-user/edit-user.module").then((m) => m.EditUserPageModule),
  },
  {
    path: "edit-team",
    loadChildren: () =>
      import("./edit-team/edit-team.module").then((m) => m.EditTeamPageModule),
  },
  {
    path: "team/:teamId",
    loadChildren: () =>
      import("./agent/team/team.module").then((m) => m.TeamPageModule),
  },
  {
    path: "edit-contract",
    loadChildren: () =>
      import("./edit-contract/edit-contract.module").then(
        (m) => m.EditContractPageModule
      ),
  },
  {
    path: "contract/:contractId",
    loadChildren: () =>
      import("./contract/contract.module").then((m) => m.ContractPageModule),
  },
  {
    path: "edit-bonus",
    loadChildren: () =>
      import("./edit-bonus/edit-bonus.module").then(
        (m) => m.EditBonusPageModule
      ),
  },
  {
    path: "bonus/:bonusId",
    loadChildren: () =>
      import("./bonus/bonus.module").then((m) => m.BonusPageModule),
  },
  {
    path: "trc20",
    loadChildren: () =>
      import("./trc20/trc20.module").then((m) => m.Trc20PageModule),
  },
  {
    path: "layout",
    loadChildren: () =>
      import("./layout/layout.module").then((m) => m.LayoutPageModule),
  },
  {
    path: "faq",
    loadChildren: () => import("./faq/faq.module").then((m) => m.FaqPageModule),
  },
  {
    path: "support",
    loadChildren: () =>
      import("./support/support.module").then((m) => m.SupportPageModule),
  },
  {
    path: "news",
    redirectTo: "list-posts",
  },
  {
    path: "products",
    loadChildren: () =>
      import("./products/products.module").then((m) => m.ProductsPageModule),
  },
  {
    path: "career",
    loadChildren: () =>
      import("./admin/career/career.module").then((m) => m.CareerPageModule),
  },
  {
    path: "files",
    loadChildren: () =>
      import("./files/files.module").then((m) => m.FilesPageModule),
  },
  {
    path: "payments",
    loadChildren: () =>
      import("./admin/payments/payments.module").then(
        (m) => m.PaymentsPageModule
      ),
  },
  {
    path: "report",
    loadChildren: () =>
      import("./admin/report/report.module").then((m) => m.ReportPageModule),
  },
  {
    path: "admin/home2",
    loadChildren: () =>
      import("./admin/home2/home2.module").then((m) => m.Home2PageModule),
  },
  {
    path: "setInfo",
    loadChildren: () =>
      import("./user/add-user-info-after-first-login/add-user-info-after-first-login.module")
              .then((m) => m.AddUserInfoAfterFirstLoginPageModule),
  },
  {
    path: "agent/home3",
    loadChildren: () =>
      import("./agent/home3/home3.module").then((m) => m.Home3PageModule),
  },
  {
    path: "my-investments",
    loadChildren: () =>
      import("./my-investments/my-investments.module").then(
        (m) => m.MyInvestmentsPageModule
      ),
  },
  {
    path: "my-profile",
    loadChildren: () =>
      import("./my-profile/my-profile.module").then(
        (m) => m.MyProfilePageModule
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: "agent/home2",
    loadChildren: () =>
      import("./agent/home2/home2.module").then((m) => m.Home2PageModule),
  },
  {
    path: "my-bonuses",
    loadChildren: () =>
      import("./my-bonuses/my-bonuses.module").then(
        (m) => m.MyBonusesPageModule
      ),
  },
  {
    path: "force-bonus",
    loadChildren: () =>
      import("./debugPages/force-bonus/force-bonus.module").then(
        (m) => m.ForceBonusPageModule
      ),
  },
  {
    path: "payment/:paymentId",
    loadChildren: () =>
      import("./payment/payment.module").then((m) => m.PaymentPageModule),
  },
  {
    path: "list-posts",
    loadChildren: () =>
      import("./wordpress/list-posts/list-posts.module").then(
        (m) => m.ListPostsPageModule
      ),
  },
  {
    path: "post-detail/:id",
    loadChildren: () =>
      import("./wordpress/post-detail/post-detail.module").then(
        (m) => m.PostDetailPageModule
      ),
  },
  {
    path: "settings",
    loadChildren: () =>
      import("./settings/settings.module").then((m) => m.SettingsPageModule),
  },
  {
    path: "faq-category",
    loadChildren: () =>
      import("./faq-category/faq-category.module").then(
        (m) => m.FaqCategoryPageModule
      ),
  },
  {
    path: "agent-support-chat/:ticketId",
    loadChildren: () =>
      import("./agent-support-chat/agent-support-chat.module").then(
        (m) => m.AgentSupportChatPageModule
      ),
  },
  {
    path: 'add-user-info-after-first-login',
    loadChildren: () => import('./user/add-user-info-after-first-login/add-user-info-after-first-login.module').then( m => m.AddUserInfoAfterFirstLoginPageModule)
  },

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
